import sessionTypes from 'helpers/enums/sessionTypes'
import actionTypes from '../actions/actionTypes'

const defaultState = {
	entity_ID: null,
	entity_type: null,
	fromStrand: null,
	fullBundleLessons: false,
	infoOpen: false,
	promoted: [],
	canAddToSchoolLibraryId: false,
	canAddToDistrictLibraryId: false,
	lessonAlreadyAdded: false,
	sessionLaunchedType: sessionTypes.UNSET,
	isExtraInformationLoaded: false,
}

function updatePreviewData(state, action) {
	const newState = {...state}
	newState.promoted = action.response.promoted.map(promotedGroup => ({
		...promotedGroup,
		entities: promotedGroup.entities.map(item => item.data.id),
	}))
	newState.infoOpen = action.response.result.data.actions.shouldExpandInfo
	newState.canAddToSchoolLibraryId = action.response.result.data.actions.canAddToSchoolLibraryId
	newState.canAddToDistrictLibraryId = action.response.result.data.actions.canAddToDistrictLibraryId
	return newState
}

function initializePreview(state, action) {
	const newState = {...state}
	newState.entity_ID = action.entity_ID
	newState.entity_type = action.entity_type
	newState.fromStrand = action.fromStrand
	newState.infoOpen = true
	return newState
}

function toggleFullLessons(state) {
	const newState = {...state}
	newState.fullBundleLessons = !state.fullBundleLessons
	return newState
}

function togglePreviewInfo(state) {
	const newState = {...state}
	newState.infoOpen = !state.infoOpen
	return newState
}

function setLessonAddedState(state) {
	const newState = {...state}
	newState.lessonAlreadyAdded = true
	return newState
}

function resetAddToPrivateLibraryFlags(state) {
	const newState = {...state}
	newState.canAddToSchoolLibraryId = false
	newState.canAddToDistrictLibraryId = false
	newState.lessonAlreadyAdded = false
	return newState
}

function previewVideoSessionLaunched(state) {
	return {
		...state,
		sessionLaunchedType: sessionTypes.PREVIEW,
	}
}

function previewVideoSessionFinished(state) {
	return {
		...state,
		sessionLaunchedType: defaultState.sessionLaunchedType,
	}
}

function updateVideoExtraInformationLoaded(state) {
	return {
		...state,
		isExtraInformationLoaded: true,
	}
}

function updatePreviewInDownloadedEntity(state, action) {
	if ( !action.payload
		|| !action.payload.presentation
		|| !action.payload.presentation.data
		|| !action.payload.presentation.data.actions
	) {
		return state
	}

	return {
		...state,
		canAddToSchoolLibraryId: action.payload.presentation.data.actions.canAddToSchoolLibraryId,
		canAddToDistrictLibraryId: action.payload.presentation.data.actions.canAddToDistrictLibraryId,
	}
}


const previewReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.STORE_PREVIEW_FETCHED:
		case actionTypes.PRIVATE_LIBRARY_PREVIEW_FETCHED:
			return updatePreviewData(state, action)
		case actionTypes.STORE_PREVIEW_INITIALIZE:
		case actionTypes.PRIVATE_LIBRARY_INITIALIZE_PREVIEW:
			return initializePreview(state, action)
		case actionTypes.PREVIEW_TOGGLE_FULL_LESSONS:
			return toggleFullLessons(state, action)
		case actionTypes.PRIVATE_LIBRARY_TOGGLE_INFO:
			return togglePreviewInfo(state)
		case actionTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT:
			return setLessonAddedState(state)
		case actionTypes.PRIVATE_LIBRARY_PREVIEW_UNMOUNT:
			return resetAddToPrivateLibraryFlags(state)
		case actionTypes.PRIVATE_LIBRARY_LAUNCH_VIDEO_PREVIEW:
		case actionTypes.MY_LIBRARY_LAUNCH_VIDEO_PREVIEW:
		case actionTypes.STORE_LAUNCH_VIDEO_PREVIEW:
			return previewVideoSessionLaunched(state)
		case actionTypes.INTERACTIVE_VIDEO_PREVIEW_SESSION_EXIT:
			return previewVideoSessionFinished(state)
		case actionTypes.INTERACTIVE_VIDEO_HANDOUTS_FETCHED:
			return updateVideoExtraInformationLoaded(state)
		case actionTypes.CART_BUY_PRODUCT_SUCCESS:
			return updatePreviewInDownloadedEntity(state, action)
		default:
			return state
	}
}

export default previewReducer
